import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
	UntypedFormControl,
	Validators,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import { ApiService } from 'src/app/services/api.services';
import { EditProfileMode } from 'src/app/ui/profile/profile.component';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
	selector: 'app-verification-code',
	templateUrl: './verification-code.component.html',
	styleUrls: ['./verification-code.component.scss'],
	imports: [
		MatFormField,
		MatLabel,
		MatInput,
		FormsModule,
		ReactiveFormsModule,
		MatError,
	],
})
export class VerificationCodeComponent {
	@Input() mobilePhoneNumber: string | undefined;
	@Input() mobileCountryCode: string | undefined;
	@Input() newEmail: string | undefined;
	@Input() userId = '';
	@Input() mode!: EditProfileMode;

	@Output() verificationCodeEventResult = new EventEmitter<boolean>();

	verificationCodeFormControl = new UntypedFormControl('', [
		Validators.required,
		Validators.pattern(/^\d{6}$/),
	]);

	constructor(private readonly apiService: ApiService) {}

	async validateCode(verificationCode?: string): Promise<void> {
		if (
			this.verificationCodeFormControl.valid &&
			verificationCode !== undefined &&
			verificationCode.length === 6
		) {
			let isValid = false;
			if (
				this.mobilePhoneNumber !== undefined &&
				this.mode === EditProfileMode.mobilePhoneNumber
			) {
				isValid = await this.apiService.verifyPhoneVerificationCode(
					this.userId,
					verificationCode,
					this.mobilePhoneNumber,
					this.mobileCountryCode
				);
			}

			if (this.newEmail !== undefined && this.mode === EditProfileMode.email) {
				isValid = await this.apiService.verifyEmailVerificationCode(
					this.newEmail,
					verificationCode
				);
			}

			if (isValid) {
				this.verificationCodeEventResult.emit(true);
			} else {
				this.verificationCodeEventResult.emit(false);
			}
		}
	}
}
